import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { ClarityModule } from '@clr/angular';
import { ActivityThumbnailComponent } from './activities-page/activity-thumbnail/activity-thumbnail.component';
import { MainHeaderComponent } from './common/main-header/main-header.component';
import { ActivitiesPageComponent } from './activities-page/activities-page.component';
import { AboutPageComponent } from './about-page/about-page.component';
import { HomePageComponent } from './home-page/home-page.component';
import { SingleActivityPageComponent } from './activities-page/single-activity-page/single-activity-page.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AbchestComponent } from './online-games/abchest/abchest.component';
import { Angulartics2Module } from 'angulartics2';
import { DisqusModule } from 'ngx-disqus';
import {TooltipModule} from 'primeng/tooltip';
import { ColoringSectionPageComponent } from './coloring-section-page/coloring-section-page.component';
import { FormsModule } from '@angular/forms';
import { LoadingComponentComponent } from './common/loading-component/loading-component.component';
import { MainFooterComponent } from './common/main-footer/main-footer.component';
import { SingleColoringPageComponent } from './coloring-section-page/single-coloring-page/single-coloring-page.component';
import { NgxPrintModule } from 'ngx-print';
import { ColoringThumbnailPostComponent } from './coloring-section-page/coloring-thumbnail-post/coloring-thumbnail-post.component';
import { PaginationComponent } from './common/pagination/pagination.component';
import { SideNavigationComponent } from './side-navigation/side-navigation.component';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { CartoonsPageComponent } from './cartoons-page/cartoons-page.component';
import { CartoonThumbnailComponent } from './cartoons-page/cartoon-thumbnail/cartoon-thumbnail.component';
import { PrivacyPolicyPageComponent } from './privacy-policy-page/privacy-policy-page.component';
import { SongsPageComponent } from './songs-page/songs-page.component';
import { SongThumbnailComponent } from './songs-page/song-thumbnail/song-thumbnail.component';
import { SingleSongPageComponent } from './songs-page/single-song-page/single-song-page.component';
import { SafePipe } from './common/utils/SafePipe';
import { ContactPageComponent } from './contact-page/contact-page.component';
import { SingleCartoonPageComponent } from './cartoons-page/single-cartoon-page/single-cartoon-page.component';
import { BackButtonComponent } from './common/back-button/back-button.component';
import { PatruImaginiComponent } from './online-games/patru-imagini/patru-imagini.component';
import {CookieService} from 'ngx-cookie-service';
import { GdprAlertComponent } from './privacy-policy-page/gdpr-alert/gdpr-alert.component';
import { SingleReviewPageComponent } from './reviews-page/single-review-page/single-review-page.component';
import { ReviewsPageComponent } from './reviews-page/reviews-page.component';
import { ReviewThumbnailComponent } from './reviews-page/review-thumbnail/review-thumbnail.component';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { BlogPageComponent } from './blog-page/blog-page.component';
import { BlogPostPageComponent } from './blog-page/blog-post-page/blog-post-page.component';
import { BlogPostThumbnailComponent } from './blog-page/blog-post-thumbnail/blog-post-thumbnail.component';
import { MenubarModule } from 'primeng/menubar';
import { InputTextModule } from 'primeng/inputtext';
import {PanelMenuModule} from 'primeng/panelmenu';
import { BasePostComponent } from './common/base-post/base-post.component';
import { BaseGridPageComponent } from './common/base-grid-page/base-grid-page.component';
import { GlobalSearchInputComponent } from './common/global-search-input/global-search-input.component';
import { SearchPageComponent } from './search-page/search-page.component';
import {SearchThumbnailComponent} from './search-page/search-thumbnail/search-thumbnail.component';
import { CraftsPageComponent } from './crafts-page/crafts-page.component';
import { SingleCraftPageComponent } from './crafts-page/single-craft-page/single-craft-page.component';
import {BaseThumbnailComponent} from './common/base-thumbnail/base-thumbnail.component';
import { DialogModule } from 'primeng/dialog';
import { SingleAudioPageComponent } from './audio-page/single-audio-page/single-audio-page.component';
import { AudioPageComponent } from './audio-page/audio-page.component';
import { AudioThumbnailComponent } from './audio-page/audio-thumbnail/audio-thumbnail.component';
import { UneltePageComponent } from './unelte-page/unelte-page.component';

@NgModule({
  declarations: [
    AppComponent,
    ActivityThumbnailComponent,
    MainHeaderComponent,
    ActivitiesPageComponent,
    AboutPageComponent,
    HomePageComponent,
    SingleActivityPageComponent,
    AbchestComponent,
    ColoringSectionPageComponent,
    LoadingComponentComponent,
    MainFooterComponent,
    SingleColoringPageComponent,
    ColoringThumbnailPostComponent,
    PaginationComponent,
    SideNavigationComponent,
    CartoonsPageComponent,
    CartoonThumbnailComponent,
    AudioPageComponent,
    AudioThumbnailComponent,
    SearchThumbnailComponent,
    PrivacyPolicyPageComponent,
    SongsPageComponent,
    SongThumbnailComponent,
    SingleSongPageComponent,
    SafePipe,
    ContactPageComponent,
    SingleCartoonPageComponent,
    SingleAudioPageComponent,
    BackButtonComponent,
    PatruImaginiComponent,
    GdprAlertComponent,
    SingleReviewPageComponent,
    ReviewsPageComponent,
    ReviewThumbnailComponent,
    BlogPageComponent,
    BlogPostPageComponent,
    BlogPostThumbnailComponent,
    BasePostComponent,
    BaseGridPageComponent,
    BaseThumbnailComponent,
    GlobalSearchInputComponent,
    SearchPageComponent,
    CraftsPageComponent,
    SingleCraftPageComponent,
    UneltePageComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ClarityModule,
    ToastrModule.forRoot(),
    Angulartics2Module.forRoot(),
    DisqusModule.forRoot('funbible'),
    NgxPrintModule,
    FontAwesomeModule,
    IvyCarouselModule,
    MenubarModule,
    InputTextModule,
    PanelMenuModule,
    TooltipModule,
    DialogModule
  ],
  providers: [ CookieService ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, far, fab);
  }
}
